import { ReactElement, useEffect, useState } from "react";
import LoadingSpinner from "../shared/LoadingSpinner";
import TabComponent from "./TabComponent";
import { Button, Card, Grid2 as Grid, Typography } from "@mui/material";
import { deleteCookie, getCookie } from "utils/cookies.util";
import { useNavigate } from "react-router";

const MainDashboard = (): ReactElement => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [usrData, setUsrData] = useState<User | null>(null);

    const hanldeLogout = () => {
        deleteCookie('usrCookie');
        setTimeout(() => navigate("/settings"), 500);
    }

    useEffect(() => {
        const usrCookie = getCookie('usrCookie');
        debugger
        setUsrData(usrCookie);
        !usrCookie && (window.location.href = '/settings');
        isLoading && setTimeout(() => { setIsLoading(false); }, 800)
    }, [isLoading])
    return <>
        <Grid container>
            <Grid size={8}>
                <Typography variant="h4">Main Dashboard</Typography>
            </Grid>
            <Grid size={3}>
                <Typography variant="h6">Welcome:  {usrData && usrData.name}</Typography>

            </Grid>
            <Grid size={1}>
                <Button onClick={hanldeLogout}>Log out</Button>
            </Grid>
        </Grid>
        <Card>
            {isLoading ? <LoadingSpinner /> : <TabComponent />}
        </Card>
    </>

}

export default MainDashboard;